/**
 * Project - fasthelp5.fa2chat-product
 *
 * @desc チャット開始パネル
 *
 * @author genka
 * @copyright Copyright 2018 TechMatrix Corporation, Inc. All rights reserved.
 */
<template>
<el-container class="fc-chat-join-pane">

  <el-main class="main-area">
    <p class="information-text">{{$t('お名前を入力し「チャットを始める」ボタンをクリックしてください。')}}</p>
    <el-form ref="fastchatUserInfoForm" :model="fastchatUserInfo" :rules="rules" @submit.native.prevent="doChatJoin">
      <el-form-item :label="$t('お名前')" prop="name">
        <el-input type="text" class="name-input" :disabled="!permissionInputFastchatUserInfoForm" v-model="fastchatUserInfo.name"></el-input>
      </el-form-item>
    </el-form>
  </el-main>

  <el-footer class="footer-area" height="auto">
    <el-button type="primary" class="chat-join-button" :disabled="!permissionChatJoin" @click="doChatJoin">{{$t('チャットを始める')}}</el-button>
  </el-footer>

</el-container>
</template>

<script>
import {
  Container,
  Main,
  Footer,
  Form,
  FormItem,
  Input,
  Button
} from 'element-ui'
import ServiceUtil from '@/utils/ServiceUtil'
import ChatMessageConst from '@/constants/ChatMessageConst'
import DialogUtil from '@/utils/DialogUtil'

export default {
  name: 'FcChatJoinPane',
  components: {
    'el-container': Container,
    'el-main': Main,
    'el-footer': Footer,
    'el-form': Form,
    'el-form-item': FormItem,
    'el-input': Input,
    'el-button': Button
  },
  data() {
    return {
      /**
       * FastChatユーザー情報
       * @type {Object}
       */
      fastchatUserInfo: {
        /**
         * お名前
         * @type {String}
         */
        name: ''
      },
      rules: {
        name: [{
          required: true,
          message: this.$t('お名前を入力してください'),
          trigger: 'blur'
        }, {
          max: this.$root.$config.chatUserNameMaxLength,
          message: this.$t('{chatUserNameMaxLength} 文字以内にしてください', {
            chatUserNameMaxLength: this.$root.$config.chatUserNameMaxLength
          }),
          trigger: 'blur'
        }]
      },
      /**
       * チャットユーザー情報のvalid状態
       * @type {Boolean}
       */
      validFastchatUserInfo: false,
      /**
       * FastChatサービス状態取得サービスをリクエスト中か
       * @type {Boolean}
       */
      requestingFindFastchatServiceStatus: false,
      /**
       * 無効状態
       * @type {Boolean}
       */
      disabled: false
    }
  },
  mounted() {
    // チャットユーザー情報のvalid状態を更新
    this.validateFastchatUserInfoForm((valid) => {
      this.validFastchatUserInfo = valid
    })
  },
  updated() {
    // チャットユーザー情報のvalid状態を更新
    this.validateFastchatUserInfoForm((valid) => {
      this.validFastchatUserInfo = valid
    })
  },
  computed: {
    /**
     * チャットユーザー情報フォームへの入力が可能か
     * @return {Boolean}
     */
    permissionInputFastchatUserInfoForm() {
      return !this.requestingFindFastchatServiceStatus && !this.disabled
    },
    /**
     * 「チャットを始める」の実行が可能か
     * @return {Boolean}
     */
    permissionChatJoin() {
      return !this.requestingFindFastchatServiceStatus && this.validFastchatUserInfo && !this.disabled
    }
  },
  methods: {
    /**
     * チャットユーザー情報フォームのvalidate処理
     * @param  {Function} callback
     */
    validateFastchatUserInfoForm(callback) {
      this.$refs['fastchatUserInfoForm'].validate((valid) => {
        callback(valid)
      })
    },
    /**
     * 「チャットを始める」処理
     */
    doChatJoin() {
      if (!this.permissionChatJoin) {
        return
      }
      this.validateFastchatUserInfoForm((valid) => {
        if (valid) {
          this.chatJoin()
        }
      })
    },
    /**
     * 「チャットを始める」処理
     */
    chatJoin() {
      ServiceUtil.request('findFastchatServiceStatusWithPreStartChat', null, {
        start: _ => {
          this.requestingFindFastchatServiceStatus = true
        },
        success: (responseData) => {
          if (responseData.status === ChatMessageConst.FASTCHAT_SERVICE_STATUS_QUIET_HOURS) {
            setTimeout(_ => {
              DialogUtil.showInfoDialog(responseData.message, _ => {
                this.$emit('chatWindowClose')
              })
            }, 0)
            return
          }
          this.$emit('chatJoin', {
            name: this.fastchatUserInfo.name
          })
        },
        error: (errorCode) => {
          DialogUtil.showErrorDialog(errorCode, _ => {
            this.$emit('chatWindowClose')
          })
        },
        end: _ => {
          this.requestingFindFastchatServiceStatus = false
        }
      })
    }
  }
}
</script>

<style scoped>
.fc-chat-join-pane {
  height: auto;
}

.main-area {
  background-color: rgb(142, 211, 251);
  flex: 2;
}

.footer-area {
  padding: 10px;
  background: #99a9bf;
}

.chat-join-button {
  width: 100%;
}

.close-button {
  background: transparent;
  border: none;
  color: white;
}
</style>



// WEBPACK FOOTER //
// src/components/chatWindow/chatJoin/FcChatJoinPane.vue